import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from 'app/store';

const selectMarketingState = (state: RootState) => state.marketing;

/**
 * Flips atomically with the one write to the slice, so the landing query string is read
 * exactly once per session (CLAUDE.md rules 7-8).
 */
export const selectHasCapturedMarketing = createSelector(
  [selectMarketingState],
  (marketingState) => marketingState.params !== null,
);

export const selectMarketingParams = createSelector(
  [selectMarketingState],
  (marketingState) => marketingState.params,
);

/** `campaign_code` — the value identityWeb sends as the enrollment payload's `campaignCode`. */
export const selectMarketingCampaignId = createSelector(
  [selectMarketingParams],
  (params) => params?.campaignId ?? null,
);

export const selectMarketingEmployeeId = createSelector(
  [selectMarketingState],
  (marketingState) => marketingState.employeeId,
);

export const selectFreeSpiritNumber = createSelector(
  [selectMarketingState],
  (marketingState) => marketingState.freeSpiritNumber,
);

export const selectCoBrand = createSelector(
  [selectMarketingState],
  (marketingState) => marketingState.coBrand,
);

export const selectIsEmbeddedInMobileApp = createSelector(
  [selectMarketingState],
  (marketingState) => marketingState.isEmbeddedInMobileApp,
);
